var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lazy-loading-spinner"},[_c('BarLoader',{staticClass:"lazy-loading-spinner__spinner",attrs:{"color":"#ef7d22","size":10,"sizeUnit":"px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }